import React from "react";

import KeywordReviewCrossAnalysis from "../KeywordReviewCrossAnalysis";
import { FeatureNames } from "../types/featureNames";
import { KeywordReviewCrossAnalysisData } from "../types/keywordReviewCrossAnalysisData";

interface IOrganizationFeaturesContentProps {
  featureName: FeatureNames;
  data: KeywordReviewCrossAnalysisData | undefined;
}

const OrganizationFeaturesContent: React.FunctionComponent<
  IOrganizationFeaturesContentProps
> = (props) => {
  switch (props.featureName) {
    case FeatureNames.KEYWORD_REVIEW_CROSS_ANALYSIS:
      return <KeywordReviewCrossAnalysis data={props.data} />;
    default:
      return null;
  }
};

export default OrganizationFeaturesContent;
